import * as types from './actionTypes';
import forgotPasswordApi from '../api/forgotPasswordApi';
import Swal from 'sweetalert2'

export function doForgotpassword(data) {
  return {
    type: types.DO_FORGOTPASSWORD,
    data
  };
}

export function doForgotpasswordRes(data) {
  return {
    type: types.DO_FORGOTPASSWORD_RES,
    data
  };
}

export function submit_forgotpassword(data) {
  return function(dispatch) {
    forgotPasswordApi.doForgotpassword(data).then(data => {
      dispatch(doForgotpasswordRes(data));
      if(data.error){
        Swal.fire({
          title: data.message,
          icon: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          timer: 3000,
          heightAuto: false
        })
      }
    }).catch(error => {
      return error
    });
  };
}